/**
 * 使用用户信息
 * @return {object} { uid: string, isLogin: boolean }
 */
export function useUser () {
    const uid = window.FEGORender.store.variable.data.UID;

    return {
        uid,
        isLogin: !!uid
    };
}
